import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
})
export class FullLayoutComponent implements OnInit {

  showHeaderFooter:boolean = false;

  constructor(
    private route:Router
  ) { }

  ngOnInit(): void {
    console.log(this.route.url, "this.route.url")
    if(this.route.url == '/createProfile' ||
    this.route.url == '/addTeams' ||
    this.route.url == '/createProfile' ||
    this.route.url == '/createProfile'){
      this.showHeaderFooter = false;
    }else{
      this.showHeaderFooter = true
    }
  }

}
